import {
  UnknownQuestionModel,
  UnknownQuestionPaginateAPIRepsonse,
  UnknownQuestionTrainOptions,
  UnknownQuestionUpdateAPI,
} from '../components/unansweredQuestions/types'
import { UnknownQuestionCreateAPI, UnkownQuestionsSearchAPI } from './types'
import { BACKEND_URL } from '../../../configs'
import API from '../../../services/api'
import { alertSuccess } from '../../../api'
import { unknownQuestionsAPIMessages } from './configs'

const template = (path = '', params = {}) => {
  let basePath: string
  if (path !== '') {
    basePath = `${BACKEND_URL}/unknown-question/${path}`
  } else {
    basePath = `${BACKEND_URL}/unknown-question`
  }
  if (Object.keys(params).length) {
    const searchParams = new URLSearchParams(params)
    return `${basePath}?${searchParams}`
  } else {
    return basePath
  }
}

const deleteQuestion = (question: UnknownQuestionModel): Promise<UnknownQuestionModel> => {
  return API.delete<UnknownQuestionModel>(template(question.id)).then(responseQuestion => {
    alertSuccess(unknownQuestionsAPIMessages.deleted)
    return responseQuestion
  })
}

const trainQuestion = (
  options: UnknownQuestionTrainOptions,
  withAlert = true,
): Promise<UnknownQuestionModel> => {
  return API.post(template('train', options)).then(responseQuestion => {
    if (withAlert) alertSuccess(unknownQuestionsAPIMessages.trained)
    return responseQuestion
  })
}

const updateQuestion = (question: UnknownQuestionUpdateAPI, withAlert = true): Promise<any> => {
  return API.put(template(), question).then(responseQuestion => {
    if (withAlert) alertSuccess(unknownQuestionsAPIMessages.updated)
    return responseQuestion
  })
}

const searchQuestions = async (params: UnkownQuestionsSearchAPI): Promise<UnknownQuestionPaginateAPIRepsonse> => {
  const requestUrl = template('', params)
  return API.get(requestUrl)
}

const getAlertMessageForQuestionCreate = (train: boolean) => {
  return train ? unknownQuestionsAPIMessages.createdAndTrained : unknownQuestionsAPIMessages.created
}

const createQuestion = async (body: UnknownQuestionCreateAPI, withAlert = true) => {
  const requestUrl = template('')
  // todo: remove request type, it is a temporary fix
  // @ts-ignore
  body.requestType = 'TRAIN_UNKNOWN_QUESTION'
  return API.post<UnknownQuestionModel>(requestUrl, body).then(responseQuestion => {
    if (withAlert) alertSuccess(getAlertMessageForQuestionCreate(body.train))
    return responseQuestion
  })
}

export const unkownQuestionService = {
  deleteQuestion,
  trainQuestion,
  updateQuestion,
  searchQuestions,
  createQuestion,
}
